export default __webpack_public_path__ + "static/media/frog_R1_C5.08e6549e.png";